export default __webpack_public_path__ + "static/media/hzs_logo.ba74189b.png";